export default {
    methods: {
        safeRedirect(path) {
            try {
                // new URL() при подобных "%E0%A4%A" значениях может кидать исключения
                const normalized = path == null || path === '' ? '/' : String(path);
                const url = new URL(normalized, window.location.origin);
                if (url.origin !== window.location.origin) {
                    window.location.assign('/');
                    return;
                }

                window.location.assign(url.href);
            } catch {
                window.location.assign('/');
            }
        },
    }
}
